<template>
    <section>
        <Hero/>
        <PageContent/>
    </section>
</template>

<script setup>
import Hero from "@/views/CompanyProfileComponents/Hero";
import PageContent from "@/views/CompanyProfileComponents/PageContent";
</script>
